import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faGithub,
  faFacebook,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faCode } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const Footer = ({ darkMode }) => {
  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
  };
  const currentYear = new Date().getFullYear();
  return (
    <footer
      className={`select-none border-t backdrop-blur-xl ${
        darkMode
          ? "bg-gray-900/90 border-gray-700/60 text-gray-300"
          : "bg-white/90 border-gray-200/60 text-gray-800"
      }`}
    >
      <div className={`w-full py-8 ${darkMode ? '' : ''}`}>
        <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 lg:gap-8">
            {/* Brand */}
            <div className="flex flex-col gap-3">
              <div
                className="flex items-center gap-3 cursor-pointer"
                onClick={() => handleNavigation("/")}
              >
                <div
                  className={`p-2 rounded-xl shadow-lg shadow-blue-500/20 ${
                    darkMode
                      ? "bg-gradient-to-br from-blue-600 to-purple-600"
                      : "bg-gradient-to-br from-blue-500 to-purple-500"
                  }`}
                >
                  <FontAwesomeIcon icon={faCode} className="text-white text-lg" />
                </div>
                <div>
                  <h2
                    className={`font-bold text-xl tracking-wide ${
                      darkMode
                        ? "bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 text-transparent bg-clip-text"
                        : "bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 text-transparent bg-clip-text"
                    }`}
                  >
                    Bhishan Sah
                  </h2>
                  <div
                    className={`h-0.5 w-0 group-hover:w-full transition-all duration-300 ${
                      darkMode
                        ? "bg-gradient-to-r from-blue-400 to-purple-400"
                        : "bg-gradient-to-r from-blue-600 to-purple-600"
                    }`}
                  ></div>
                </div>
              </div>
              <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                Building reliable, elegant, and performant web experiences.
              </p>
              <img
                src="https://lh3.googleusercontent.com/d/14sLIkgCbcsYCy1OGhKba086qr5NnGJzs"
                alt="My Signature"
                className={`w-fit h-7 -rotate-12 select-none ${
                  darkMode ? "brightness-0 invert" : "brightness-200 contrast-200"
                }`}
              />
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-bold mb-3">Quick Links</h3>
              <div className={`h-0.5 w-16 mb-4 rounded-full ${darkMode ? 'bg-blue-400' : 'bg-blue-600'}`}></div>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { label: 'Home', path: '/' },
                  { label: 'About', path: '/about' },
                  { label: 'Projects', path: '/projects' },
                  { label: 'Contact', path: '/contact' },
                  { label: 'News', path: '/my-blogs' },
                  { label: 'Gallery', path: '/gallery' },
                ].map((link) => (
                  <button
                    key={link.path}
                    onClick={() => handleNavigation(link.path)}
                    className={`text-left px-3 py-2 rounded-lg text-sm transition-colors ${
                      darkMode
                        ? 'hover:bg-gray-800/60 text-gray-300 hover:text-white'
                        : 'hover:bg-gray-100 text-gray-700 hover:text-gray-900'
                    }`}
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-lg font-bold mb-3">Contact</h3>
              <div className={`h-0.5 w-16 mb-4 rounded-full ${darkMode ? 'bg-blue-400' : 'bg-blue-600'}`}></div>
              <div className="space-y-2 text-sm">
                <a href="tel:+44-07344064548" className="flex items-center gap-3 group">
                  <span className={`h-8 w-8 rounded-lg flex items-center justify-center ${darkMode ? 'bg-blue-500/15 text-blue-300' : 'bg-blue-600/10 text-blue-700'}`}>
                    <FontAwesomeIcon icon={faPhone} />
                  </span>
                  <span className="group-hover:underline">+44-07344064548</span>
                </a>
                <a href="mailto:bhishansah@gmail.com" className="flex items-center gap-3 group break-all">
                  <span className={`h-8 w-8 rounded-lg flex items-center justify-center ${darkMode ? 'bg-blue-500/15 text-blue-300' : 'bg-blue-600/10 text-blue-700'}`}>
                    <FontAwesomeIcon icon={faEnvelope} />
                  </span>
                  <span className="group-hover:underline">bhishansah@gmail.com</span>
                </a>
                <div className="flex items-start gap-3">
                  <span className={`h-8 w-8 rounded-lg flex items-center justify-center ${darkMode ? 'bg-blue-500/15 text-blue-300' : 'bg-blue-600/10 text-blue-700'}`}>
                    <FontAwesomeIcon icon={faLocationDot} />
                  </span>
                  <p>Village-Rauthat, R.M Balan-bihul-6, Saptari Nepal.  currentely Living In The UK.</p>
                </div>
              </div>
            </div>

            {/* Social */}
            <div>
              <h3 className="text-lg font-bold mb-3">Social</h3>
              <div className={`h-0.5 w-16 mb-4 rounded-full ${darkMode ? 'bg-blue-400' : 'bg-blue-600'}`}></div>
              <div className="flex flex-wrap gap-3">
                <a href="https://wa.me/919728161275?text=Hello!%20How%20are%20you." target="_blank" rel="noopener noreferrer" className={`h-9 w-9 rounded-xl flex items-center justify-center transition-all ${darkMode ? 'bg-white/5 hover:bg-white/10' : 'bg-black/5 hover:bg-black/10'}`}>
                  <FontAwesomeIcon icon={faWhatsapp} className="text-green-500" />
                </a>
                <a href="https://www.instagram.com/bhishansah/" target="_blank" rel="noopener noreferrer" className={`h-9 w-9 rounded-xl flex items-center justify-center transition-all ${darkMode ? 'bg-white/5 hover:bg-white/10' : 'bg-black/5 hover:bg-black/10'}`}>
                  <FontAwesomeIcon icon={faInstagram} className="text-pink-500" />
                </a>
                <a href="https://www.linkedin.com/in/bhishansah/" target="_blank" rel="noopener noreferrer" className={`h-9 w-9 rounded-xl flex items-center justify-center transition-all ${darkMode ? 'bg-white/5 hover:bg-white/10' : 'bg-black/5 hover:bg-black/10'}`}>
                  <FontAwesomeIcon icon={faLinkedin} className="text-blue-600" />
                </a>
                <a href="https://github.com/visionmax01" target="_blank" rel="noopener noreferrer" className={`h-9 w-9 rounded-xl flex items-center justify-center transition-all ${darkMode ? 'bg-white/5 hover:bg-white/10 text-gray-300' : 'bg-black/5 hover:bg-black/10 text-gray-800'}`}>
                  <FontAwesomeIcon icon={faGithub} />
                </a>
                <a href="https://www.facebook.com/share/qJntLSmzjo3uB8HV/?mibextid=qi2Omg" target="_blank" rel="noopener noreferrer" className={`h-9 w-9 rounded-xl flex items-center justify-center transition-all ${darkMode ? 'bg-white/5 hover:bg-white/10' : 'bg-black/5 hover:bg-black/10'}`}>
                  <FontAwesomeIcon icon={faFacebook} className={`${darkMode ? 'text-blue-400' : 'text-blue-800'}`} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Subfooter */}
      <div className={`border-t ${darkMode ? 'border-gray-700/60' : 'border-gray-200/80'}`}>
        <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-center">
          <p className={`text-xs sm:text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            &copy; {currentYear} Bhishan prasad Sah - All rights reserved.
          </p>
          <p className="text-xs opacity-70">Last Updated On - 14th November 2025 at 1:00 AM</p>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  darkMode: PropTypes.bool.isRequired,
};

export default Footer;
